import {CommentsEventLogger} from '../../../services/analytics/comments';
import {articleMapper} from '../../mappers/comments/article-mapper';
import {commentMapper} from '../../mappers/comments/comment-mapper';
import {validateCommentMessage} from '../../models/comment';
import {commentHttpRepository} from '../../repositories/comments-http-repository';
import {CommentsMemoryRepository} from '../../repositories/comments-memory-repository';
import {withAuthCheck} from '../../utils/fetch';

export const saveComment = (commentText, parentCommentId, article, user) => {
  const comment = commentMapper.toApi(commentText, parentCommentId, articleMapper.toAPI(article));
  const validationBodyErrorText = validateCommentMessage(commentText);

  if (validationBodyErrorText) {
    throw Error(`Comment validation error: ${validationBodyErrorText}`);
  }

  return withAuthCheck(() => commentHttpRepository.save(comment)
    .then(response => {

      if (response.tokenError) {
        return {
          isSucces: false,
          tokenError: true
        };
      }

      const createdCommentId = response.id;

      if (typeof createdCommentId !== 'string') {
        comment.parentCommentId
          ? CommentsEventLogger.publishChildCommentReplyError(response?.message, article.id)
          : CommentsEventLogger.publishMainCommentError(response?.error, article.id);

        return {
          isSucces: false,
          code: response?.statusCode
        };
      }

      comment.parentCommentId
        ? CommentsEventLogger.publishChildCommentReplySuccess(article.id)
        : CommentsEventLogger.publishMainCommentSuccess(article.id);

      CommentsMemoryRepository.addReply(parentCommentId, commentMapper.toDomain({
        ...comment,
        id: createdCommentId,
        createdAt: new Date().toISOString(),
        recentlyAdded: true,
        user
      }));

      return {
        isSucces: true
      };
    })
  );
};
